var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditEmployee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.664,
    height: 15.664,
    viewBox: "0 0 15.664 15.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    transform: "translate(-2.93 -2.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_142",
    "data-name": "Vrstva 142",
    transform: "translate(2.93 2.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M9.8,17.836l8.04-8.04a2.591,2.591,0,0,0,0-3.662L15.392,3.69a2.591,2.591,0,0,0-3.662,0l-8.04,8.04a2.591,2.591,0,0,0-.76,1.831V18.6H7.965a2.591,2.591,0,0,0,1.831-.76ZM4.614,13.518a.864.864,0,0,1,.25-.6l8.049-8.049a.864.864,0,0,1,1.218,0l2.444,2.444a.864.864,0,0,1,0,1.218L8.569,16.619a.864.864,0,0,1-.6.25H4.657Z",
    transform: "translate(-2.93 -2.933)",
    fill: "#4b5960"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEmployee);
export default __webpack_public_path__ + "static/media/edit_employee.41100e0240aa6c141387ea1a1645d603.svg";
export { ForwardRef as ReactComponent };